import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  Heading,
  LoaderIndicator,
  SelectionBox,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import {
  getInvestmentProfiles,
  IInvestmentProfile
} from '@/modules/catalog/services/funds';


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const router = useRouter();

const updateData = inject('updateData', (key: string, data: object) => ({
  key,
  data
}));

const isLoading = ref(true);
const profiles = ref<IInvestmentProfile[] | null>(null);
const selectedOption = ref('');

const options = computed(() => {
  return profiles.value?.map(item => {
    return {
      title: item.formatted,
      value: item.value
    };
  });
});

const selectedOptionFormatted = computed(() => {
  const data = profiles.value?.filter(
    item => item.value === selectedOption.value
  );

  return data![0];
});

const isDisabled = computed(() => {
  return !selectedOption.value;
});

function handleChangeOption(value: string) {
  selectedOption.value = value;
}

function onClick() {
  updateData('profile', selectedOptionFormatted.value);
}

async function fetchInvestmentProfiles() {
  try {
    isLoading.value = true;

    profiles.value = await getInvestmentProfiles();
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível carregar as informações. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });

    router.push({ name: 'catalog' });
  } finally {
    isLoading.value = false;
  }
}

onMounted(async () => {
  await fetchInvestmentProfiles();
});

return { __sfc: true,router, updateData, isLoading, profiles, selectedOption, options, selectedOptionFormatted, isDisabled, handleChangeOption, onClick, fetchInvestmentProfiles, Heading, LoaderIndicator, SelectionBox, ButtonContainer, ButtonPrimary }
}

})